import React from 'react'
import createClass from 'create-react-class'

import DaysView from './daysview.jsx'
import MonthsView from './monthsview.jsx'
import YearsView from './yearsview.jsx'
import TimeView from './timeview.jsx'

var CalendarContainer = createClass({
  viewComponents: {
    days: DaysView,
    months: MonthsView,
    years: YearsView,
    time: TimeView
  },

  render: function () {
    return React.createElement(
      this.viewComponents[this.props.view],
      this.props.viewProps
    )
  }
})

export default CalendarContainer
